module.exports = __webpack_public_path__ + "static/media/des-escolares-sf.1b2df43c.png";